import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

interface AdminAuthState {
  username: string;
  password: string;
  isAuthenticated: boolean;
}

const ADMIN_CREDENTIALS = {
  username: 'berkongroup',
  password: 'BerkonGroup@1616'
};

export function useAdminAuth() {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(() => {
    const stored = localStorage.getItem('adminAuth');
    return stored === 'true';
  });
  
  const navigate = useNavigate();
  const location = useLocation();

  const login = (username: string, password: string): boolean => {
    if (username === ADMIN_CREDENTIALS.username && password === ADMIN_CREDENTIALS.password) {
      setIsAuthenticated(true);
      localStorage.setItem('adminAuth', 'true');
      return true;
    }
    return false;
  };

  const logout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem('adminAuth');
    navigate('/admin/login');
  };

  const updatePassword = (currentPassword: string, newPassword: string): boolean => {
    if (currentPassword === ADMIN_CREDENTIALS.password) {
      // In a real application, this would update the backend
      // For now, we'll store in localStorage (not secure for production)
      const updatedCredentials = {
        ...ADMIN_CREDENTIALS,
        password: newPassword
      };
      localStorage.setItem('adminCredentials', JSON.stringify(updatedCredentials));
      return true;
    }
    return false;
  };

  const getStoredCredentials = () => {
    const stored = localStorage.getItem('adminCredentials');
    return stored ? JSON.parse(stored) : ADMIN_CREDENTIALS;
  };

  return {
    isAuthenticated,
    login,
    logout,
    updatePassword,
    getStoredCredentials
  };
}
